import { SocialIcon } from 'react-social-icons/component'
import 'react-social-icons/facebook'
import 'react-social-icons/x'

function XIcon() {
    const textToAddInPost = `I support our planet.  Join me and support this global movement.

Click the link to join and plant your first super tree for free.

`;
    const urlToAddInPost = `https://www.planetecosystem.com/site/signup?sm=1`;
    const twitterHref = encodeURI(`https://x.com/intent/post?text=${textToAddInPost}&url=${urlToAddInPost}&hashtags=blueplanetecosystem,planetecosystem,healthyplanet,saveourplanet,planttrees`);
    return <SocialIcon style={{ height: '40px', width: '40px' }} bgColor='#005A92' url="www.x.com" href={twitterHref} />
}

export { XIcon };